import { ServiceCenterListResponse } from '@/modules/insurers/serviceCenters/services/apiValidation/serviceCenterListApiValidation'
import { ServiceCenterDetailResponse } from '@/modules/insurers/serviceCenters/services/apiValidation/serviceCenterDetailApiValidation.ts'

export const serviceCentersPage1: { data: ServiceCenterListResponse } = {
  data: {
    results: [
      {
        id: '1',
        name: '[ NGT ] - NAIGUATA',
        email: 'naiguata@ally.com',
        phone: '02122345678',
        state: 'LA GUAIRA',
        businessName: 'ACCESORIOS NAPOLES, C.A',
        rif: 'J-502968555',
        address:
          'AVENIDA LOS MANGOS CON CALLE VICTORIA, LOCAL NRO. 1, PARROQUIA NAIGUAT\u00c1, MUNICIPIO VARGAS DEL ESTADO\u00a0LA\u00a0GUAIRA',
        latitude: '10.62077652',
        longitude: '-66.73995210',
        googleMapsLocation:
          'https://www.google.com/maps/place/Av.+Los+Mangos+%26+C.+Victoria,+Naiguat%C3%A1+1166,+La+Guaira/@10.620735,-66.7398723,120m/data=!3m1!1e3!4m6!3m5!1s0x8c2a4e3cd52a3f7f:0x690327a05e6f96d!8m2!3d10.6207532!4d-66.7398723!16s%2Fg%2F11h9y4nzz4?entry=ttu\u0026g_ep=EgoyMDI1MDcwNi4wIKXMDSoASAFQAw%3D%3D',
        commercialAllyId: '212',
        commercialAllyName: 'Ally_210',
        createdAt: '18/03/2026',
        updatedAt: null,
        createdBy: null,
        updatedBy: null
      },
      {
        id: '2',
        name: '[ CDO ] - CEDENO',
        email: 'naiguata@ally.com',
        phone: '02122345678',
        state: 'CARABOBO',
        businessName: 'ACCESORIOS CANGURO, C.A.',
        rif: 'J-311424571',
        address:
          'AVENIDA BOLIVAR CON AVENIDA CEDE\u00d1O Y CALLE ARISMENDI, CENTRO COMERCIAL CEDE\u00d1O, NIVEL PLANTA BAJA, LOCAL NRO. 11',
        latitude: '10.18710778',
        longitude: '-68.00456538',
        googleMapsLocation:
          'https://www.google.com/maps/place/Canguro+C.C+Cede%C3%B1o/@10.1870609,-68.0071582,868m/data=!3m2!1e3!4b1!4m6!3m5!1s0x8e8067004b226299:0x16a8c2e268c37ce3!8m2!3d10.1870556!4d-68.0045833!16s%2Fg%2F11w3mmrf8v?entry=ttu\u0026g_ep=EgoyMDI1MDQwMi4xIKXMDSoASAFQAw%3D%3D',
        commercialAllyId: '212',
        commercialAllyName: 'Ally_210',
        createdAt: '18/03/2026',
        updatedAt: null,
        createdBy: null,
        updatedBy: null
      },
      {
        id: '3',
        name: '[ CRR ] - CARORA',
        email: 'naiguata@ally.com',
        phone: '02122345678',
        state: 'LARA',
        businessName: 'DISTRICUEROS EL CANGURO, C.A',
        rif: 'J-308565202',
        address:
          'AV 14 DE FEBRERO ENTRE CALLES LARA Y CARABOBO EDIF ANIBAL ALDAZORO PB CARORA',
        latitude: '10.17438157',
        longitude: '-70.08113694',
        googleMapsLocation:
          'https://www.google.com/maps/place/Canguro+Carora/@10.1743225,-70.081205,21z/data=!4m12!1m5!3m4!2zMTDCsDEwJzI4LjMiTiA3MMKwMDQnNTIuMSJX!8m2!3d10.174519!4d-70.081133!3m5!1s0x8e87ed19cbf4b55d:0xf3b65c74db039d23!8m2!3d10.174371!4d-70.0811342!16s%2Fg%2F11txry1f_w?entry=ttu\u0026g_ep=EgoyMDI1MDQwMS4wIKXMDSoASAFQAw%3D%3D',
        commercialAllyId: '212',
        commercialAllyName: 'Ally_210',
        createdAt: '18/03/2026',
        updatedAt: null,
        createdBy: null,
        updatedBy: null
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 0,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  }
}

export const serviceCenterDetails: { data: ServiceCenterDetailResponse } = {
  data: {
    id: '1',
    name: '[ NGT ] - NAIGUATA',
    email: 'naiguata@ally.com',
    phone: '02122345678',
    state: 'LA GUAIRA',
    businessName: 'ACCESORIOS NAPOLES, C.A',
    rif: 'J-502968555',
    address:
      'AVENIDA LOS MANGOS CON CALLE VICTORIA, LOCAL NRO. 1, PARROQUIA NAIGUAT\u00c1, MUNICIPIO VARGAS DEL ESTADO\u00a0LA\u00a0GUAIRA',
    latitude: '10.62077652',
    longitude: '-66.73995210',
    googleMapsLocation:
      'https://www.google.com/maps/place/Av.+Los+Mangos+%26+C.+Victoria,+Naiguat%C3%A1+1166,+La+Guaira/@10.620735,-66.7398723,120m/data=!3m1!1e3!4m6!3m5!1s0x8c2a4e3cd52a3f7f:0x690327a05e6f96d!8m2!3d10.6207532!4d-66.7398723!16s%2Fg%2F11h9y4nzz4?entry=ttu\u0026g_ep=EgoyMDI1MDcwNi4wIKXMDSoASAFQAw%3D%3D',
    commercialAllyId: '1',
    commercialAllyName: 'Ally_210',
    createdAt: '18/03/2026',
    updatedAt: null,
    createdBy: null,
    updatedBy: null
  }
}
